module.exports = __webpack_public_path__ + "static/media/400015_02.ac78500e.png";